import QtdBookingsCard from "./RccCards/QtdBookingsCard";
import YtdBookingsCard from "./RccCards/YtdBookingsCard";
import QtrProjectionCard from "./RccCards/QtrProjectionCard";
import PerformanceInsightsCard from "./RccCards/PerformanceInsightsCard";
import LinearityComparisonCard from "./RccCards/LinearityComparisonCard";
import TeamWiseCurrentQtrProjeectionCard from "./RccCards/TeamWiseCurrentQtrProjeectionCard";
import WonACVByTeamCard from "./RccCards/WonACVByTeamCard";
import PipelineMixByTeamCard from "./RccCards/PipelineMixByTeamCard";
import PipelineMixByLeadSourceCategoryCard from "./RccCards/PipelineMixByLeadSourceCategoryCard";
import PipelineMixByIndustryCard from "./RccCards/PipelineMixByIndustryCard";
import PipelineMixByLeadSourceCard from "./RccCards/PipelineMixByLeadSourceCard";
import WonACVByLeadSourceCategoryCard from "./RccCards/WonACVByLeadSourceCategoryCard";
import WonACVByIndustryCard from "./RccCards/WonACVByIndustryCard";
import WonACVByLeadSourceCard from "./RccCards/WonACVByLeadSourceCard";
import PipelineMixBySolutionCategoryCard from "./RccCards/PipelineMixBySolutionCategoryCard";
import WonACVBySolutionCategoryCard from "./RccCards/WonACVBySolutionCategoryCard";
import PipelineMixByDealCategoryCard from "./RccCards/PipelineMixByDealCategoryCard";
import WonACVByDealCategoryCard from "./RccCards/WonACVByDealCategoryCard";
import PipelineMixByProductLineCard from "./RccCards/PipelineMixByProductLineCard";
import WonACVByProductLineCard from "./RccCards/WonACVByProductLineCard";
import PipelineMixByCustomerTypeCard from "./RccCards/PipelineMixByCustomerTypeCard";
import PipelineMixByOpportunityRecordTypeCard from "./RccCards/PipelineMixByOpportunityRecordTypeCard";
import WonACVByCustomerTypeCard from "./RccCards/WonACVByCustomerTypeCard";
import WonACVByOpportunityRecordTypeCard from "./RccCards/WonACVByOpportunityRecordTypeCard";
import PipelineMixByCustomerSegmentCard from "./RccCards/PipelineMixByCustomerSegmentCard";
import PipelineMixBySalesTypeCard from "./RccCards/PipelineMixBySalesTypeCard";
import WonACVByCustomerSegmentCard from "./RccCards/WonACVByCustomerSegmentCard";
import WonACVBySalesTypeCard from "./RccCards/WonACVBySalesTypeCard";
import AverageCycleTimeCard from "./RccCards/AverageCycleTimeCard";
import LostReasonTrend from "./RccCards/LostReasonTrend";
import AverageDealSizeTrend from "./RccCards/AverageDealSizeTrend";
import ShiftInValueOfOppLost from "./RccCards/ShiftInValueOfOppLost";
import WinRateTrend from "./RccCards/WinRateTrend";
import PipelineCoverage from "./RccCards/PipelineCoverage";
import NudgeCard from "./RccCards/NudgeCard";
import PullInCard from "./RccCards/PullInCard";
// Monthly versions of linearity/projection cards
// These cards use monthly Time Series data and are only enabled for specific customers (e.g., C0017)
import MonthlyLinearityComparisonCard from "./RccCards/MonthlyLinearityComparisonCard";
import TeamWiseCurrentMonthProjectionCard from "./RccCards/TeamWiseCurrentMonthProjectionCard";
import FreshNewQualifiedPipelineCard from "./RccCards/FreshNewQualifiedPipelineCard";
import PipelineCreatedByTeamRaid9Card from "./RccCards/PipelineCreatedByTeamRaid9Card";
import PipelineCreatedByTeamRoamingDNACard from "./RccCards/PipelineCreatedByTeamRoamingDNACard";

// Registry of all available cards: id -> Component
// Card visibility is controlled via INT_RCC_Cards_To_UI_Role_ID_Mapping database table
const cardRegistry = {
  RCC_QTD_Bookings: QtdBookingsCard,
  RCC_YTD_Bookings: YtdBookingsCard,
  RCC_Qtr_Projection: QtrProjectionCard,
  RCC_Performance_Insights: PerformanceInsightsCard,
  RCC_Linearity_Comparison: LinearityComparisonCard,
  RCC_Team_Wise_Current_Qtr_Projection: TeamWiseCurrentQtrProjeectionCard,
  RCC_Won_ACV_By_Team: WonACVByTeamCard,
  RCC_Won_ACV_By_Lead_Source_Category: WonACVByLeadSourceCategoryCard,
  RCC_Won_ACV_By_Lead_Source: WonACVByLeadSourceCard,
  RCC_Won_ACV_By_Industry: WonACVByIndustryCard,
  RCC_Won_ACV_By_Customer_Type: WonACVByCustomerTypeCard,
  RCC_Won_ACV_By_Opportunity_Record_Type: WonACVByOpportunityRecordTypeCard,
  RCC_Won_ACV_By_Customer_Segment: WonACVByCustomerSegmentCard,
  RCC_Won_ACV_By_Sales_Type: WonACVBySalesTypeCard,
  RCC_Won_ACV_By_Solution_Category: WonACVBySolutionCategoryCard,
  RCC_Won_ACV_By_Deal_Category: WonACVByDealCategoryCard,
  RCC_Won_ACV_By_Product_Line: WonACVByProductLineCard,
  RCC_Pipeline_Mix_By_Team: PipelineMixByTeamCard,
  RCC_Pipeline_Mix_By_Lead_Source_Category: PipelineMixByLeadSourceCategoryCard,
  RCC_Pipeline_Mix_By_Lead_Source: PipelineMixByLeadSourceCard,
  RCC_Pipeline_Mix_By_Industry: PipelineMixByIndustryCard,
  RCC_Pipeline_Mix_By_Customer_Type: PipelineMixByCustomerTypeCard,
  RCC_Pipeline_Mix_By_Opportunity_Record_Type:
    PipelineMixByOpportunityRecordTypeCard,
  RCC_Pipeline_Mix_By_Customer_Segment: PipelineMixByCustomerSegmentCard,
  RCC_Pipeline_Mix_By_Sales_Type: PipelineMixBySalesTypeCard,
  RCC_Pipeline_Mix_By_Solution_Category: PipelineMixBySolutionCategoryCard,
  RCC_Pipeline_Mix_By_Deal_Category: PipelineMixByDealCategoryCard,
  RCC_Pipeline_Mix_By_Product_Line: PipelineMixByProductLineCard,
  RCC_Average_Cycle_Time: AverageCycleTimeCard,
  RCC_Lost_Reason_Trend: LostReasonTrend,
  RCC_Average_Deal_Size_Trend: AverageDealSizeTrend,
  RCC_Shift_In_Value_Of_Opp_Lost: ShiftInValueOfOppLost,
  RCC_Win_Rate_Trend: WinRateTrend,
  RCC_Pipeline_Coverage: PipelineCoverage,
  RCC_Nudge: NudgeCard,
  RCC_Pull_In: PullInCard,
  RCC_Monthly_Linearity_Comparison: MonthlyLinearityComparisonCard,
  RCC_Team_Wise_Current_Month_Projection: TeamWiseCurrentMonthProjectionCard,
  RCC_Fresh_New_Qualified_Pipeline: FreshNewQualifiedPipelineCard,
  RCC_Pipeline_Created_By_Team_Raid_9: PipelineCreatedByTeamRaid9Card,
  RCC_Pipeline_Created_By_Team_Roaming_DNA: PipelineCreatedByTeamRoamingDNACard,
};

/**
 * Get card component by ID
 * @param {string} cardId - The ID of the card to retrieve
 * @returns {React.Component|null} Card component or null if not found
 */
export function getCard(cardId) {
  return cardRegistry[cardId] || null;
}

/**
 * Get all registered card IDs
 * @returns {Array} Array of card IDs
 */
export function getAllCardIds() {
  return Object.keys(cardRegistry);
}

export default cardRegistry;
